import { APICall } from "@/config/NetworkUtility";

const createValidator = ({ endpoint, queryKey, fieldName }) => {
    return async (value = "") => {
        try {
            const trimmedValue = String(value).trim();

            // Empty
            if (!trimmedValue) {
                return {
                    valid: false,
                    message: `${fieldName} is required`,
                };
            }

            const response = await APICall(
                "get",
                null,
                `v1/CompanySetup/${endpoint}?${queryKey}=${encodeURIComponent(
                    trimmedValue
                )}`
            );

            const available = response?.data === "Available";

            return {
                valid: available,
                message: available
                    ? `${fieldName} is available`
                    : `${fieldName} already taken`,
            };
        } catch (error) {
            console.error(`${fieldName} validation error:`, error);

            return {
                valid: false,
                message:
                    error?.response?.data?.message ||
                    error?.message ||
                    `Unable to validate ${fieldName}`,
            };
        }
    };
};

// Reusable validators
export const validateEmail = createValidator({
    endpoint: "ValidateEmailId",
    queryKey: "EmailId",
    fieldName: "Email",
});

export const validateUsername = createValidator({
    endpoint: "ValidateUsername",
    queryKey: "Username",
    fieldName: "Username",
});

export const validateCompanyName = createValidator({
    endpoint: "ValidateCompanyName",
    queryKey: "CompanyName",
    fieldName: "Company Name",
});